export enum FilterCategory {
	ADDITIONAL_ATTRIBUTES = "Additional attributes",
	LEAD_CATEGORIZATION_AND_SCORING = "Lead Categorization & Scoring",
	FREQUENTLY_USED = "Frequently used",
	LINKEDIN_ENGAGEMENT = "Linkedin Engagement",
	MAPS = "Maps",
	JOBS = "Jobs",
	LI_POST = "LI Post",
	LI_PROFILE = "LI Profile",
	LI_COMPANY_ACTIVITY = "LI Company Activity",
	LI_EVENT_ENTRY = "LI Event Entry",
	EVENTS = "Events",
	CUSTOM_COLUMNS = "Custom columns",
}
